import { action } from 'satcheljs';
import { Publisher } from '../../../../@data';

export const onSetPublisherReporting = action('onSetPublisherReporting', (publisher: Publisher) => ({ publisher }));

export const onReportingEnabled = action('onSetPublisherReporting', (isEnabled: boolean) => ({ isEnabled }));
